<div class="col-xs-12 col-lg-6 mb-2">
  @if (userPromptDetailedData?.id) {
    <div class="p-2 fw-semibold mb-2">
      Changes to this mobile form will not affect past records.
    </div>
  }

  <div class="form-floating mb-2">
    <input
      type="text"
      class="form-control"
      [(ngModel)]="promptName"
      placeholder="Mobile Form Name "
      (input)="initializeToolTip()"
    />
    <label>Mobile Form Name </label>
  </div>

  @if (promptName || paginatedPromptData?.length) {
    @if (paginatedPromptData?.length > 1) {
      <div class="py-2 border-top border-5 strong row">
        <div class="col-lg-4 mb-1">
          <button
            [disabled]="page === 0"
            (click)="changePagination(false)"
            class="mx-3"
          >
            <i class="fas fa-arrow-left"></i>
          </button>
          <span>
            Page {{ page + 1 }} of {{ paginatedPromptData?.length }}
          </span>
          <button
            [disabled]="page + 1 === paginatedPromptData?.length"
            (click)="changePagination()"
            class="mx-3"
          >
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    }
    <div class="d-flex align-items-center mb-2 px-2">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="showOnHome"
          (change)="showOnHome = !showOnHome"
          id="showOnHomeCheckbox"
        />
        <label class="form-check-label" for="showOnHomeCheckbox">
          <span [ngClass]="showOnHome ? 'fw-semibold' : ''">
            Show on Home Screen
          </span>
        </label>
      </div>
      <span
        class="ms-1"
        tabindex="0"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Only visible on mobile devices."
      >
        <i class="fa-solid fa-circle-question fs-5 text-success"></i>
      </span>
    </div>
    <div
      class="py-2 border-5 row"
      [ngClass]="
        promptName !== userPromptDetailedData?.name &&
        userPromptDetailedData?.id
          ? 'row-cols-3'
          : 'row-cols-2'
      "
    >
      <div class="col">
        <button
          type="button"
          class="btn btn-md btn-success w-100"
          (click)="previewPrompts()"
          [disabled]="disabeSaveButton()"
        >
          Preview Form
        </button>
      </div>
      <div class="col">
        <button
          type="button"
          class="btn btn-md btn-primary w-100"
          (click)="savePrompts()"
          [disabled]="disabeSaveButton()"
        >
          {{ userPromptDetailedData?.id ? "Update" : "Save" }}
        </button>
      </div>
      <div class="col">
        @if (
          promptName !== userPromptDetailedData?.name &&
          userPromptDetailedData?.id
        ) {
          <button
            class="btn btn-primary btn-md"
            (click)="copyPrompt()"
            [disabled]="promptName === userPromptDetailedData?.name"
          >
            Save As
          </button>
        }
      </div>
    </div>
    <div class="col-xs-12">
      @for (field of selectedPagePrompts; track field; let i = $index) {
        <div class="mb-3 card p-1 p-lg-2">
          <div>
            <ng-template
              *ngTemplateOutlet="
                formTemplate;
                context: {
                  value: field,
                  index: i,
                  arrayList: selectedPagePrompts,
                  mainSection: true,
                }
              "
            ></ng-template>
          </div>
        </div>
      }
    </div>
    <div id="section_types">
      <dt>Section Types</dt>
      <div class="d-flex flex-wrap gap-3">
        @for (opt of addPromptOptions; track opt) {
          <div
            role="button"
            class="bg-primary-subtle p-2 px-3 border text-uppercase rounded text-center flex-grow-1 text-dark"
            (click)="addItem(opt)"
          >
            <span class="fw-semibold"> + {{ opt.promptLabel }} </span>
          </div>
        }
      </div>
    </div>
  }

  <div class="row row-cols-3 mt-3">
    <div class="col">
      <button
        type="button"
        class="btn btn-md btn-dark w-100"
        (click)="goBack()"
      >
        Cancel
      </button>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-md btn-success w-100"
        (click)="previewPrompts()"
        [disabled]="disabeSaveButton()"
      >
        Preview Form
      </button>
    </div>
    <div class="col">
      <button
        type="button"
        class="btn btn-md btn-primary w-100"
        (click)="savePrompts()"
        [disabled]="disabeSaveButton()"
      >
        {{ userPromptDetailedData?.id ? "Update" : "Save" }}
      </button>
    </div>
  </div>
</div>

<ng-template
  #formFieldOptionsTemplateRef
  let-formFieldOptionsTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Section Type
      <span
        class="float-end"
        (click)="formFieldOptionsTemplateRef.close('close')"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="d-flex flex-wrap gap-3 p-3">
      @for (opt of addPromptOptions; track opt) {
        <div
          role="button"
          class="bg-primary-subtle p-2 px-3 border text-uppercase rounded text-center text-dark"
          (click)="
            addItem(opt, data?.option); formFieldOptionsTemplateRef.close()
          "
        >
          <span class="fw-semibold"> + {{ opt.promptLabel }} </span>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template
  let-field="value"
  let-index="index"
  let-arrayList="arrayList"
  let-mainSection="mainSection"
  let-nestedKey="nestedKey"
  let-outerField="outerField"
  #formTemplate
>
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="small">
      @if (mainSection) {
        <span class="text-secondary text-uppercase"
          >SECTION {{ index + 1 }}:
        </span>
      }
      @if (!mainSection) {
        <span class="text-secondary"
          >{{ outerField?.description }} > {{ nestedKey }}
        </span>
      }
      @if (mainSection) {
        <span class="text-uppercase">
          {{ field | misc: "promptLabel" : addPromptOptions }}
        </span>
      }
    </div>
    <div>
      <span (click)="deleteSection(arrayList, index)">
        <i class="fa-solid fa-circle-minus fs-5 text-danger"></i
      ></span>
    </div>
  </div>

  <div class="d-flex gap-2 mb-2">
    @if (mainSection && selectedPagePrompts?.length > 1) {
      <div class="form-floating order-input-width">
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          list="numbers"
          class="form-control text-center"
          [min]="1"
          [max]="selectedPagePrompts?.length"
          [value]="index + 1"
          autocomplete="off"
          (change)="onPositionChange(index, $event)"
        />
        <label>Order</label>
        <datalist id="numbers">
          @for (number of selectedPagePromptsIndexList; track number) {
            <option [value]="number">
              {{ number }}
            </option>
          }
        </datalist>
      </div>
    }

    @if (field.type === "output") {
      <div class="flex-grow-1">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="field.description"
            placeholder="Heading Title*"
          />
          <label>Heading Title*</label>
        </div>
      </div>
    }

    @if (field.type === "input") {
      <div class="flex-grow-1">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="field.description"
            placeholder="Description / Question"
          />
          <label>Description / Question</label>
        </div>
      </div>
    }
  </div>
  @if (field.type === "input") {
    <div class="d-flex gap-2 flex-column">
      @if (field?.field === "checkbox") {
        @if (field.options?.length) {
          <div
            cdkDropList
            #currentList="cdkDropList"
            [cdkDropListData]="field.options"
            class="drag-drop-container drag-list mt-3 ps-3"
            (cdkDropListDropped)="drop($event)"
          >
            @for (opt of field.options; track opt; let i = $index) {
              <div class="mb-3 cursor-grab">
                <div class="d-flex drag-box" cdkDrag>
                  <div class="pe-1" cdkDragHandle>
                    <span class="me-2">
                      <i class="fa-solid fa-bars"></i>
                    </span>
                  </div>
                  <div class="flex-grow-1">{{ opt?.key }}</div>
                  @if (!field?.singleChoice) {
                    <div (click)="field?.options?.splice(i, 1)" class="mx-3">
                      <i class="fa-solid fa-circle-minus fs-5 text-danger"></i>
                    </div>
                  }
                  <!--nested feature-->
                  <div
                    (click)="
                      openTemplate(formFieldOptionsTemplateRef, field, opt)
                    "
                  >
                    <i class="fas fa-plus-circle fs-5 text-success"></i>
                  </div>
                </div>
                <!--nested feature structure-->
                <div>
                  @if (opt?.selectSubOptions?.length) {
                    @for (
                      subField of opt?.selectSubOptions;
                      track subField;
                      let subIndex = $index
                    ) {
                      <div class="nested-prompt shadow rounded p-1 p-lg-2 my-2">
                        <ng-template
                          *ngTemplateOutlet="
                            formTemplate;
                            context: {
                              value: subField,
                              index: subIndex,
                              arrayList: opt?.selectSubOptions,
                              mainSection: false,
                              nestedKey: opt?.key,
                              outerField: field,
                            }
                          "
                        ></ng-template>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (field?.singleChoice !== 1) {
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Add Option"
                  [(ngModel)]="tempOption"
                />
                <label> Add Answer </label>
              </div>
            </div>
            <div class="ms-1">
              <button
                type="button"
                [disabled]="!tempOption"
                class="btn btn-lg btn-success w-100 h-100"
                (click)="
                  tempOption ? field.options.push({ key: tempOption }) : '';
                  tempOption = ''
                "
              >
                <i class="fas fa-plus-circle"></i>
              </button>
            </div>
          </div>
          <div class="form-floating">
            <input
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              (input)="maxSelectionsAllowedValidation($event, field)"
              title="This determines the maximum number of options a user can select."
              class="form-control"
              [(ngModel)]="field.allowedSelections"
              placeholder="Answers Allowed "
            />
            <label>Answers Allowed</label>
          </div>
        }
      } @else if (field?.field == "text") {
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="field.value"
            placeholder="Default Value (Optional)"
          />
          <label>Default Value</label>
        </div>
      } @else {
        <div class="p-1 text-center d-flex">
          <div
            class="bg-body-secondary text-body-emphasis rounded border border-secondary px-3 py-2"
            role="button"
          >
            <i class="fa-solid fa-camera fs-5"></i>
            <div>Take Photo</div>
          </div>
        </div>
      }
      <div class="col d-flex gap-2 flex-column ps-3">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="requiredField{{ index }}"
            [(ngModel)]="field.required"
          />
          <label for="requiredField{{ index }}">Required</label>
          <span
            class="ms-1"
            tabindex="0"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="If ticked, the user must enter a value."
          >
            <i class="fa-solid fa-circle-question fs-5 text-success"></i>
          </span>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [(ngModel)]="field.showInReports"
            id="reportField{{ index }}"
          />
          <label for="reportField{{ index }}"> Show in all reports</label>
          <span
            class="ms-1"
            tabindex="0"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="If unticked, this information is only available under Reports > Prompts."
          >
            <i class="fa-solid fa-circle-question fs-5 text-success"></i>
          </span>
        </div>
      </div>
    </div>
  }
</ng-template>
